/**
 * Per-tab memory of which studies had the echo measurements panel open.
 *
 * The panel must stay CLOSED by default and reopen only when the user had it
 * open in that same study earlier in this tab (returning to the study, an HMR
 * remount, a reload). A globally persisted "open" flag is wrong here — it
 * makes one left-open panel auto-open on every future echo study, on every
 * device the settings sync to. sessionStorage keeps the memory per tab;
 * it is cleared on logout so a shared workstation never replays one user's
 * layout to the next.
 */
const ECHO_PANEL_OPEN_KEY = 'viewer.echoPanelOpenStudies';
function readSet() {
    try {
        const raw = sessionStorage.getItem(ECHO_PANEL_OPEN_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.filter((v) => typeof v === 'string') : [];
    }
    catch {
        return [];
    }
}
function writeSet(ids) {
    try {
        sessionStorage.setItem(ECHO_PANEL_OPEN_KEY, JSON.stringify(ids));
    }
    catch {
        // Storage unavailable — the panel simply won't restore; never throw.
    }
}
export function rememberEchoPanelOpen(studyId) {
    const ids = readSet();
    if (!ids.includes(studyId))
        writeSet([...ids, studyId]);
}
export function forgetEchoPanelOpen(studyId) {
    const ids = readSet();
    if (ids.includes(studyId))
        writeSet(ids.filter((id) => id !== studyId));
}
export function wasEchoPanelOpen(studyId) {
    return readSet().includes(studyId);
}
export function clearEchoPanelMemory() {
    try {
        sessionStorage.removeItem(ECHO_PANEL_OPEN_KEY);
    }
    catch {
        // Storage unavailable — nothing was stored anyway.
    }
}
